import { unifiedAuthStrategy } from './auth-strategies/index.js';

export const { isLoggedIn: isLoggedInToAccount } = unifiedAuthStrategy;

export { logout } from './logout.js';
export { getUserInfo } from './auth-data.js';
export type { UserInfo } from './schemas.js';
export { useAuth } from './useAuth.js';
export { ApiKeyLogin } from './components/ApiKeyLogin.js';
export { RefreshTokenLogin } from './components/RefreshTokenLogin.js';
export { LoginWithI18n as Login } from './components/Login.js';
export { AuthProvider } from './providers/UnifiedAuthProvider.js';
export { SiteAuthProvider } from './providers/SiteAuthProvider.js';
export { useSiteAuth } from './hooks/useSiteAuth.js';
export { authenticateWithSiteId } from './authenticate.js';
export type { AuthState } from './context.js';
